<div class="flex gap-4 w-full min-h-24 max-h-24 bg-white/70 items-center">
    <div class="items-center px-4 lg:hidden">
        <button mat-icon-button (click)="navOpen = !navOpen">
            <mat-icon *ngIf="!navOpen" svgIcon="streamline-regular:navigation-menu"></mat-icon>
            <mat-icon class="icon-size-4" *ngIf="navOpen" svgIcon="streamline-regular:close"></mat-icon>
        </button>
    </div>

    <div class="flex justify-center pr-14 md:justify-start lg:pl-8 lg:pr-20">
        <div
            *ngIf="organisation$ | async as org"
            class="flex h-full w-fit select-none flex-col items-center justify-center"
        >
            <img class="max-h-12 w-fit" [src]="org?.logo" />
            <div class="flex w-full items-end justify-end gap-x-1.5 pr-5">
                <span class="text-xs leading-none">{{ "general.powered_by" | translate }}</span>
                <img class="w-15" src="./assets/images/logo-municipal.svg" />
            </div>
        </div>
    </div>

    <div class="hidden lg:flex flex-auto items-center">
        <ng-container *ngTemplateOutlet="navigationItems"></ng-container>
    </div>

    <div class="hidden md:flex flex-auto justify-end pr-2">
        <nerri-user-menu></nerri-user-menu>
    </div>
</div>

<div id="overlay-nav" class="overlay flex flex-col bg-extra-light-blue border-t-2" [class.visible]="navOpen">
    <div class="flex flex-col flex-auto justify-between p-12 md:py-0 md:justify-center">
        <ng-container *ngTemplateOutlet="navigationItems"></ng-container>

        <div class="md:hidden">
            <nerri-user-menu></nerri-user-menu>
        </div>
    </div>
</div>

<ng-template #navigationItems>
    <div class="flex flex-col md:flex-row gap-12">
        <div class="flex flex-col md:flex-row items-baseline md:items-center gap-4">
            <div
                class="navigation-item flex gap-4 items-center cursor-pointer"
                routerLink="/dashboard/home"
                routerLinkActive="active-item"
                [routerLinkActiveOptions]="{ exact: true }"
            >
                <mat-icon class="icon-size-6" svgIcon="streamline-regular:layout-dashboard"></mat-icon>

                <span class="text-xl select-none">{{ "navigation.dashboard" | translate }}</span>
            </div>
        </div>

        <div class="flex flex-col md:flex-row items-baseline md:items-center gap-4">
            <div
                class="navigation-item flex gap-4 items-center cursor-pointer"
                routerLink="/dashboard/home/my-properties"
                routerLinkActive="active-item"
            >
                <mat-icon class="icon-size-6" svgIcon="streamline-regular:maps-pin-1"></mat-icon>

                <span class="text-xl select-none">{{ "navigation.my_properties" | translate }}</span>
            </div>
        </div>
    </div>
</ng-template>
